import { widgetInitialisation } from "./widget-init";
import { ElementsEnumerator } from "./element-enumerator";

const initializedVueAppAttrName = "data-vue-initialized";

export var WidgetInitializer = function (elementsClass) {
    this.elementsClass = elementsClass;
};

WidgetInitializer.prototype.initialize = function (initializationCallback) {
    var that = this;
    widgetInitialisation(function () {
        return innerInitialization.call(that, initializationCallback);
    });
};

function innerInitialization(initializationCallback) {
    var elementsEnumerator = new ElementsEnumerator(this.elementsClass);
    var notInitializedElements = elementsEnumerator.getElements();
    for (var i = 0; i < notInitializedElements.length; i++) {
        var element = notInitializedElements[i];
        if (element.hasAttribute(initializedVueAppAttrName))
            return;

        var newElement = initializationCallback(element);
        if (newElement)
            { element = newElement; }

        element.setAttribute(initializedVueAppAttrName, '');
    }
};